





















import { Component, Prop, Vue } from 'vue-property-decorator';

// see : view-source:https://www.w3.org/2010/05/video/script.js

const NO_ERROR:string = '';
const DEBUG_MONITOR:boolean = false;

@Component({
    data() { return {
        errorMessage: NO_ERROR,
        statusMessage: 'initing',
        currentDuration: 0,
        intervalID: 0,
        hasSeen: false,
    } },
    computed: {
        showError():boolean { return this.$data.errorMessage != NO_ERROR },
        showClick():boolean { return !this.$data.hasSeen }
    },
    mounted():void {
        let video: HTMLVideoElement = <HTMLVideoElement>this.$refs.video;
        let readyStates: string[] = ['nothing', 'metadata', 'current_data', 'future_data', 'enough_data'];
        let networkStates: string[] = ['empty', 'idle', 'loading', 'no_source'];
        let _instance: VideoPlayer = <VideoPlayer>this;
        let update = function (): void {

            if (DEBUG_MONITOR) {
                console.log(networkStates[video.networkState], readyStates[video.readyState]);
            }

            _instance.$data.statusMessage = [
                'network: ', networkStates[video.networkState],
                '<br>ready: ', readyStates[video.readyState],
                '<br>source: ', video.currentSrc,
                '<br>time: ', video.currentTime,
                ' / ', video.duration
            ].join('');

            let videoIsWorking:boolean = video.networkState == 1 && video.readyState > 1;
            if( videoIsWorking && !video.paused || video.currentTime > 0 ) {
                _instance.$data.hasSeen = true;
            }

            /*
                0 = NETWORK_EMPTY - audio/video has not yet been initialized
                1 = NETWORK_IDLE - audio/video is active and has selected a resource, but is not using the network
                2 = NETWORK_LOADING - browser is downloading data
                3 = NETWORK_NO_SOURCE - no audio/video source found

                --

                0 = HAVE_NOTHING - no information whether or not the audio/video is ready
                1 = HAVE_METADATA - metadata for the audio/video is ready
                2 = HAVE_CURRENT_DATA - data for the current playback position is available, but not enough data to play next frame/millisecond
                3 = HAVE_FUTURE_DATA - data for the current and at least the next frame is available
                4 = HAVE_ENOUGH_DATA - enough data available to start playing
             */
                };

        //update();
        this.$data.intervalID = window.setInterval(update, 1000);
    },
    beforeDestroy():void {
        window.clearInterval(this.$data.intervalID);
    },
    methods: {
        handleVideoPlaying(e):void {
            this.$data.hasSeen = true;
            console.log('video is playing', e);
            if( this.$props.skipped ) {
                let video = (<HTMLVideoElement>this.$refs.video);
                console.log('starting video skipped', video.duration);
                video.currentTime = video.duration;
                //video.pause();
            }
        },
        handleVideoAbort(e):void {
            //console.log(e);
        },
        handleVideoEvent(e):void {
            //console.log(e);
            if( e.type === 'error') {
                this.$data.errorMessage = this.$props.videoURL;
            }
        },
        handleEnded(e):void {
            //console.log(e);
            this.$data.hasSeen = true;
            this.$emit('video-ended');
        },
        handleDurationChange(e):void {
            //console.log(e);
            let video = (<HTMLVideoElement>this.$refs.video);
            this.$data.currentDuration = video.duration;
            //console.log(e, video.currentTime, video.duration);
        },
        handleVideoClick(e):void {
            let video = (<HTMLVideoElement>this.$refs.video);
            let time = video.currentTime;
            //console.log('[video-markers]', this.$props.videoURL, ' @', time, 'secs');
        },
        handlePlayClicked(e):void {
            let video = (<HTMLVideoElement>this.$refs.video);
            try {
                video.play();
            } catch {
                console.error('could not play video, even after click');
            }
        }
    },
    watch: {
        videoURL(v):void {
            // zou alleen af moeten gaan als video URL verandert.
            (<HTMLVideoElement>this.$refs.video).load();
        },
        skipped(v):void {
            // om de video te laten skippen
            //console.log('Video.skipped', v);
            //console.log(video, video.paused, video.currentTime, video.duration, this.$data.currentDuration)
            if( v ) {
                let video = (<HTMLVideoElement>this.$refs.video);
                this.$data.hasSeen = true;
                video.pause();
                video.currentTime = this.$data.currentDuration;
            }
            // else {
            //     video.play();
            // }
        }
    }
})
export default class VideoPlayer extends Vue {
    @Prop() private videoURL!: string;
    @Prop() private skipped!: boolean;
}
